import Lying from "../Lying";

export default class Complete extends Lying {
	public static code = "skirting_lying_complete";
}
